// extracted by mini-css-extract-plugin
module.exports = {"authReminderModal":"AuthReminder_authReminderModal__1agLS","title":"AuthReminder_title__38mE6","subtitle":"AuthReminder_subtitle__8oNUa","buttons":"AuthReminder_buttons__2BX4i"};